import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
// Root reducer
import { rootReducer } from "reducers/rootReducer";
// Router
import { browserHistory } from 'react-router';
import { routerMiddleware } from 'react-router-redux';
export function configureStore(initialState = {}) {
    // Create the router middleware
    const router = routerMiddleware(browserHistory);
    // Create the store
    if (process.env.NODE_ENV === "production") {
        return createStore(rootReducer, applyMiddleware(thunk, router));
    }
    else {
        const composeEnhancers = typeof window === "object" &&
            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
            window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
            // Specify extension�s options like name, actionsBlacklist, actionsCreators, serialize...
            }) : compose;
        const enhancer = composeEnhancers(applyMiddleware(thunk, router));
        return createStore(rootReducer, enhancer);
    }
    //// Enable Webpack hot module replacement for reducers    
    //if (module.hot) {
    //    module.hot.accept("../reducers", () => {
    //        const nextReducer = require("reducers") as Reducer;
    //        store.replaceReducer(nextReducer);
    //    });
    //}
}
